export const dataMixin = {
	data() {
		return {
			dataMixin_headerList: [ // 表头
				{
					prop: 'product_title',
					label: '退款课程',
					width: 260
				},
				{
					prop: 'refund_amount',
					label: '退款金额/件数',
					align: 'center',
					width: 150
				},
				{
					prop: 'type',
					label: '退款类型/原因',
					// width: 220,
					showOverflowTooltip: true
				},
				{
					prop: 'status',
					label: '退款状态',
					width: 180
				},
				// {
				// 	prop: 'logistics_status',
				// 	label: '物流状态'
				// },
				// {
				// 	prop: 'talent_name',
				// 	label: '推广人抖音昵称',
				// 	width: 150
				// },
				// {
				// 	prop: 'buyer_nickname',
				// 	label: '购买人',
				// 	width: 140
				// },
			],
			dataMixin_stateList: [ // 退款状态列表
				{
					value: '',
					label: '全部'
				},
				{
					value: 1,
					label: '待退款', 
					showRest: true, // 展示剩余时间
					showAgreeBtn: true, // 展示同意按钮
					showRejectBtn: true // 展示拒绝按钮
				},
				{
					value: 2,
					label: '退款中'
				},
				{
					value: 3,
					label: '退款成功'
				},
				{
					value: 4,
					label: '退款失败'
				},
				{
					value: 5,
					label: '追缴成功'
				},
			],
			dataMixin_reasonList: [ // 退款原因
				{
					"reason": "",
					"reason_text": "全部"
				},{
					"reason": "10000000",
					"reason_text": "不想要了"
				}, {
					"reason": "10000001",
					"reason_text": "缺货"
				}
			],
			dataMixin_tabStateList: [
				{
					label: '全部',
					value: ''
				},
				{
					label: '待处理',
					value: '1',
					showNum: true, // 展示数量
					showBadge: true // 展示红点
				},
				{
					label: '24小时待处理',
					value: '2',
				},
				{
					label: '待打款',
					value: '3'
				},
				{
					label: '逾期未退款',
					value: '4'
				}
			]
		}
	}
}